// extracted by mini-css-extract-plugin
export default {"ScrollProgress":"ScrollProgress_ScrollProgress__CvXlT","Bar":"ScrollProgress_Bar__A7dSZ"};